import React from 'react';
import PropTypes from 'prop-types';
import {
  TextField,
  ToggleSwitch,
  Label,
  Divider,
  Checkbox,
} from 'mw-style-react';
import useIntl from 'useIntl';
import mes from './intl';
// eslint-disable-next-line no-unused-vars
import m from '../../../app/src/components/Modal/Modal.scss'; // NOSONAR
// eslint-disable-next-line no-unused-vars
import l from '../../../app/src/components/Modal/main/CreateActorAccount/CreateActorAccount.scss'; // NOSONAR

function AccAdvancedOptions(props) {
  const { values, disabled, handleOnChange, errors, addPlan = true } = props;
  const t = useIntl();
  const renderTextField = (field) => {
    const { id, type, label } = field;
    return (
      <TextField
        id={id}
        styleName="m.textfield l.block__field"
        type={type}
        label={label}
        bordered={true}
        value={values[id] || ''}
        error={!!errors[id]}
        helperText={t(mes[errors[id]])}
        onChange={handleOnChange}
        visibility={disabled ? 'disabled' : 'visible'}
        onKeyPress={(e) => {
          if (e.key === 'e') e.preventDefault();
        }}
      />
    );
  };

  return (
    <>
      <div styleName="l.block l.advanced">
        <Label
          styleName="l.block__label"
          fontWeight="semibold"
          value={t(mes.setupLimits)}
        />
        {renderTextField({
          id: 'minLimit',
          type: 'float',
          label: t(mes.minAccLimit),
        })}
        {renderTextField({
          id: 'maxLimit',
          type: 'float',
          label: t(mes.maxAccLimit),
        })}
      </div>
      <div styleName="l.block l.advanced">
        <ToggleSwitch
          id="treeCalculation"
          styleName="l.block__switch"
          value={values.treeCalculation}
          visibility={disabled ? 'disabled' : 'visible'}
          onChange={handleOnChange}
        />
        <Label value={t(mes.useTreeCalculation)} />
      </div>
      <div styleName="l.block l.advanced">
        <ToggleSwitch
          id="search"
          styleName="l.block__switch"
          value={values.search}
          visibility={disabled ? 'disabled' : 'visible'}
          onChange={handleOnChange}
        />
        <Label value={t(mes.showAccInSearch)} />
      </div>
      {addPlan ? (
        <>
          <Divider styleName="l.divider" />
          <div styleName="l.block l.advanced">
            <Label
              styleName="l.block__label"
              fontWeight="semibold"
              value={t(mes.planAccInfo)}
            />
            <Checkbox
              id="addPlan"
              styleName="l.radio"
              value={values.addPlan}
              onChange={handleOnChange}
            >
              <Label value={t(mes.createWithPlan)} />
            </Checkbox>
          </div>
        </>
      ) : null}
    </>
  );
}

AccAdvancedOptions.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  addPlan: PropTypes.bool,
  disabled: PropTypes.bool,
  handleOnChange: PropTypes.func,
};

export default AccAdvancedOptions;
